import { render, staticRenderFns } from "./CollectorMetrics.vue?vue&type=template&id=0e8ee766"
import script from "./CollectorMetrics.vue?vue&type=script&lang=js"
export * from "./CollectorMetrics.vue?vue&type=script&lang=js"
import style0 from "./CollectorMetrics.vue?vue&type=style&index=0&id=0e8ee766&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8ee766')) {
      api.createRecord('0e8ee766', component.options)
    } else {
      api.reload('0e8ee766', component.options)
    }
    module.hot.accept("./CollectorMetrics.vue?vue&type=template&id=0e8ee766", function () {
      api.rerender('0e8ee766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Logs/CollectorMetrics.vue"
export default component.exports